import { type VoteType } from '../../../types/alternatives-voting'
import { ThumbsUp, ThumbsDown } from 'lucide-react'

interface VoteButtonsProps {
  alternativeId: string
  upvotes: number
  downvotes: number
  userVote?: VoteType
  onVote?: (alternativeId: string, voteType: VoteType) => void
}

export function VoteButtons({
  alternativeId,
  upvotes,
  downvotes,
  userVote,
  onVote,
}: VoteButtonsProps) {
  const handleVote = (voteType: VoteType) => {
    onVote?.(alternativeId, voteType)
  }

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={() => handleVote('upvote')}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all border-2 ${
          userVote === 'upvote'
            ? 'bg-amber-500/10 border-amber-500/30 text-amber-500'
            : 'bg-slate-800 border-slate-700 text-slate-300 hover:bg-slate-700 hover:text-amber-400 hover:border-amber-500/20'
        }`}
      >
        <ThumbsUp className="w-4 h-4" />
        <span>{upvotes}</span>
      </button>
      <button
        onClick={() => handleVote('downvote')}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all border-2 ${
          userVote === 'downvote'
            ? 'bg-rose-500/10 border-rose-500/30 text-rose-500'
            : 'bg-slate-800 border-slate-700 text-slate-300 hover:bg-slate-700 hover:text-rose-400 hover:border-rose-500/20'
        }`}
      >
        <ThumbsDown className="w-4 h-4" />
        <span>{downvotes}</span>
      </button>
    </div>
  )
}
